import { TOOL_METADATA, TOOLS_INDEX_METADATA } from '../data/toolCatalog';
import { TOOL_GUIDE } from '../data/toolGuide';
import { TOOL_SEO, toolOgImage } from '../data/toolSeo';
import { SITE_ORIGIN } from './seo/orgSchema';
import { toolSchemaGraph, toolUrl } from './seo/toolSchema';

/** The one owner of every free tool page's head: meta, canonical, card, and JSON-LD. */
export const toolHead = (slug: string) => {
  const metadata = slug ? TOOL_METADATA[slug] : TOOLS_INDEX_METADATA;
  if (!metadata) throw new Error(`Missing tool metadata for ${slug}`);
  const faq = slug ? TOOL_SEO[slug]?.faq : undefined;
  if (slug && !faq) throw new Error(`Missing tool discovery copy for ${slug}`);
  const guide = slug ? TOOL_GUIDE[slug] : undefined;
  if (slug && !guide) throw new Error(`Missing tool guide for ${slug}`);
  const { title, description } = metadata;
  const url = toolUrl(slug);
  // Per-tool card; the tools index inherits the sitewide og-v10 card from __root.
  const image = slug ? `${SITE_ORIGIN}${toolOgImage(slug)}` : null;
  return {
    meta: [
      { title },
      { name: 'description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      ...(image
        ? [
            { property: 'og:image', content: image },
            { name: 'twitter:image', content: image },
          ]
        : []),
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { 'script:ld+json': toolSchemaGraph(slug, metadata, faq ?? [], guide?.steps ?? []) },
    ],
    links: [{ rel: 'canonical', href: url }],
  };
};
